import React from 'react'
import './Story.css'
import StoryHeader from './StoryHeader'
import StoryBody from './StoryBody'
import StoryFooter from './StoryFooter'

type Props = {
  story: {
    info?: storyInfo,
    contents?: storyContent[],
  },
}
export default function Story(props: Props) {
  if (!props?.story?.info || !props?.story?.contents) {
    return null
  }
  return (
    <>
      <StoryHeader info={props.story.info} />
      <StoryBody contents={props.story.contents} />
      <StoryFooter info={props.story.info} />
    </>
  )
}
